export default {"src":"/_next/static/media/whatsapp.fd1caef2.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};